import React from "react";
import styles from "./page.module.css";
import {ContinueButton} from "../../../../components/continue-button/continue-button";
import {Header} from "../header/header";

const Page = (props) => {
    const defaultButtonStyles = {
        backgroundColor: "rgb(33, 51, 112)",
        fontSize: '18px',
        boxShadow: 'none',
        borderRadius: '150px',
    };
    return (
            <div className={styles.page}>
                <Header {...props}/>
                <div className={styles.page_content}>
                    <div>
                        <h1 className={styles.title}>{props.title}</h1>
                    </div>
                    {props.children}
                    {!props.hideContinueButton &&
                        <ContinueButton link={props.nextPageLink} text={props.btnText} onClick={props.onContinue}
                                        enabled={props.canGoToNextPage}
                                        buttonStyles={props.buttonStyles || defaultButtonStyles}/>}
                </div>
            </div>
    );
};

export {Page};
